module.exports = __webpack_public_path__ + "img/Asset_SINPE_M.568ddd10.png";